<template>
  <transition
    :name="name"
    :mode="mode"
    :duration="duration"
  >
    <slot />
  </transition>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'TransitionAnimation',
    props: {
      name: {
        type: String,
        default: 'fade',
      },

      mode: {
        type: String,
        default: 'out-in',
      },

      duration: {
        type: Number,
        default: 300,
      },
    },
  });
</script>

<style lang="scss" scoped>
  $transition-duration: 0.3s;

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity $transition-duration ease-out;
    will-change: opacity;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
